import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Award, Check } from 'react-feather';
import { Modal, ModalHeader } from 'reactstrap';
import useCallApi from '../../../hooks/useCallApi';
import callAPI from '../../../helpers/callAPI';

export default function PerformanceBonus({ affiliate, parentLoaded, showSystemMessage }) {
    
    // Get bonus info from DB?
    const [optinModalOpen, setOptinModalOpen] = useState(false)
    const [optedIn, setOptedIn] = useState(false)    

    const {data, dataLoaded, refetch} = useCallApi(`bonus/performance`, 'GET', {}, [], showSystemMessage)

    useEffect(()=>{
        setOptedIn(affiliate.affiliate_flags.includes(185))
    }, [affiliate])
   
    const progressBarClass = (progressPercent) => {
        if (progressPercent < 100){
            return 'bg-primary'
        } else {
            return 'bg-success'
        }
    }

    const optin = async () => {
        let result = await callAPI(`bonus/performance/optin`, 'POST', {}, [])
        if (result.success){
            setOptedIn(true)            
        } else {
            showSystemMessage('error', result.errors.message)
        }        
    }

    return (
        dataLoaded &&
        <>
            <Modal isOpen={optinModalOpen} toggle={()=>setOptinModalOpen(!optinModalOpen)} className="modal-md">
                <div className="card">
                    <ModalHeader toggle={()=>setOptinModalOpen(!optinModalOpen)}>Performance Bonus</ModalHeader>                    
                    <div className="card-body">
                        New MaxBounty affiliates can now earn up to $10,000 in bonus earnings with our new affiliate performance bonus program.<br /><br />
                        
                        In order to be eligible, you must opt-in to the program.<br /><br />

                        Your registration date: <strong>{moment(affiliate.registration_date).format('MMMM Do, YYYY')}</strong><br />
                        Bonus period end date: <strong>{moment(affiliate.registration_date).add(3, 'months').format('MMMM Do, YYYY')}</strong><br /><br />

                        <div className="border p-2 rounded mb-3">
                            <strong>Tier 1:</strong> Earn above $5,000 cumulatively in the first 3 months to qualify for a bonus of $1,000.
                            { data.performance_bonus.completed_tier === 1 && <div className="text-success">You have qualified for tier 1.</div> }
                        </div>

                        <div className="border p-2 rounded mb-3">
                            <strong>Tier 2:</strong> Earn above $50,000 cumulatively in the first 3 months to qualify for a bonus of $10,000.
                            { data.performance_bonus.completed_tier === 2 && <div className="text-success">You have qualified for tier 2.</div> }
                        </div>

                        {!optedIn ?
                            <div className="text-center mb-3"><button onClick={()=>optin()} className="btn btn-primary">Opt-in</button></div>
                        :
                            <>
                                <div className="alert alert-success text-center">You are opted-in.</div>
                                {(affiliate.registration_date && moment().isAfter(moment(affiliate.registration_date).add(3, 'months'))) &&
                                    // Promo period is over
                                    <div className="alert alert-success text-center">Promo period has ended.</div>
                                }
                            </>
                        }
                        
                        <div className="text-muted font-italic" style={{fontSize: '0.9rem'}}>
                            You must opt-in to the program to be eligible for the bonus. You can opt-in at any time before the end of your bonus period.<br /><br />
                            Your qualified earnings will be finalized 1 month after the end of your bonus period, and if your qualified earnings exceed the required amounts for any of the tiers, you will receive your payment on your next scheduled payment date.<br /><br />
                            Bonuses will be paid out at the discretion of MaxBounty.
                        </div> 
                    </div>
                </div>
            </Modal>
            {
                parentLoaded ?
                    (optedIn && moment().isBefore(moment(affiliate.registration_date).add(4, 'months'))) ?
                            // Registered... We should show them their progress regardless of if it's past 3 months. We basically show this forever.                        
                            <div className="p-2 d-flex flex-column align-items-end justify-content-end performanceBonusContainer performanceBonusBackground text-white">
                                <div className="d-flex align-items-center mb-1 w-100">
                                {moment().isAfter(moment(affiliate.registration_date).add(3, 'months')) ?
                                    // Promo period has ended
                                    <>
                                        {(data.performance_bonus.completed_tier === 1 || data.performance_bonus.completed_tier === 2) ?
                                            // Qualified
                                            <button onClick={() => setOptinModalOpen(true)} className="btn btn-link text-primary font-weight-bold mx-auto p-0 d-flex align-items-center" style={{ whiteSpace: 'nowrap', textDecoration: 'none' }} >
                                                <span>🎉</span> <span className="maxmoney-gold mx-2">Performance Bonus Unlocked!</span> <span>🎉</span>
                                            </button>
                                            :
                                            // Did not qualify
                                            <>                                                                                   
                                                <button onClick={() => setOptinModalOpen(true)} className="btn btn-link text-primary font-weight-bold mr-2 p-0" style={{ whiteSpace: 'nowrap', textDecoration: 'none' }} >
                                                    <span style={{fontSize: '1rem'}}>💎</span> <span className="text-uppercase">Promo Ended</span>
                                                </button>                                        
                                                
                                                <div className="progress flex-grow-1 mr-2 mt-1 rounded" style={{ height: '6px', position: 'relative', whiteSpace: 'nowrap', overflow: 'visible' }}>
                                                    <div className={`progress-bar rounded ${progressBarClass(data.performance_bonus.progress_percent)}`} role="progressbar" style={{ width: `${data.performance_bonus.progress_percent}%` }} aria-valuenow={data.performance_bonus.progress_percent} aria-valuemin="0" aria-valuemax="100" />
                                                </div>

                                                <span className="ml-2">
                                                    <strong>${Intl.NumberFormat('en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(data.performance_bonus.promotion_earnings)}</strong> / ${Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(data.performance_bonus.current_target)}
                                                </span>
                                            </>
                                        }
                                    </>
                                :
                                    // Promo period is ongoing
                                    data.performance_bonus.completed_tier < 3 &&
                                        <>                                                                                   
                                            <button onClick={() => setOptinModalOpen(true)} className="btn btn-link text-primary font-weight-bold mr-2 p-0" style={{ whiteSpace: 'nowrap', textDecoration: 'none' }} >
                                                <span style={{fontSize: '1rem'}}>💎</span> <span className="text-uppercase">Bonus {data.performance_bonus.current_tier}</span>
                                            </button>                                        
                                            
                                            <div className="progress flex-grow-1 mr-2 mt-1 rounded" style={{ height: '6px', position: 'relative', whiteSpace: 'nowrap', overflow: 'visible' }}>
                                                <div className={`progress-bar rounded ${progressBarClass(data.performance_bonus.progress_percent)}`} role="progressbar" style={{ width: `${data.performance_bonus.progress_percent}%` }} aria-valuenow={data.performance_bonus.progress_percent} aria-valuemin="0" aria-valuemax="100" />
                                            </div>

                                            <span className="ml-2">
                                                <strong>${Intl.NumberFormat('en-GB', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(data.performance_bonus.promotion_earnings)}</strong> / ${Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(data.performance_bonus.current_target)}
                                            </span>
                                        </>
                                }                                                              
                                </div>
                            </div>
                       
                        :
                            (affiliate.registration_date && moment().isBefore(moment(affiliate.registration_date).add(3, 'months'))) ?
                                <div className="performanceBonusContainer performanceBonusBackground p-2">
                                    <div className="d-flex align-items-center justify-content-center">   
                                        <div style={{fontSize: '1rem'}}>💎</div>
                                        <button className="shiny-button" data-text={"Get up to $10,000 if you qualify for the performance bonus!"} onClick={() => setOptinModalOpen(true)}>                        
                                            Get up to $10,000 if you qualify for the performance bonus!
                                        </button>
                                    </div>
                                </div>
                            :
                                <>{/* This is an affiliate who is older than 3 months old and never opted in. */}</>
                        

                :
                    ''
            }
        </>        
    )
}